(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown-timer"] && !Shopify.designMode) return;
  try {
    class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
      this.updateTimer = this.updateTimer.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.formatNumber = (n) => String(n).padStart(2, '0');
    }
    
    connectedCallback() {
      this.startTimer();
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      document.addEventListener('shopify:section:load', () => {
        if (this.contains(event.target) || event.target.contains(this)) {
          this.startTimer();
        }
      });
    }
    
    disconnectedCallback() {
      this.stopTimer();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
    
    handleVisibilityChange() {
      if (document.hidden) {
        this.stopTimer();
      } else {
        this.startTimer();
      }
    }
    
    startTimer() {
      this.stopTimer();
      
      if (this.dataset.endDate === 'auto') {
        const now = new Date();
        const defaultEnd = new Date(now.getTime() + (24 * 60 * 60 * 1000));
        this.dataset.endDate = defaultEnd.toISOString();
      }
      
      this.updateTimer();
      this.interval = setInterval(this.updateTimer, 1000);
    }
    
    stopTimer() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
    
    updateTimer() {
      const now = Date.now();
      let endTime = new Date(this.dataset.endDate).getTime();
      let timeLeft = Math.max(endTime - now, 0);
      
      if (timeLeft === 0 && this.dataset.behavior === 'cycle') {
        const cycleMs = parseFloat(this.dataset.cycleHours) * 60 * 60 * 1000;
        endTime = now + cycleMs;
        this.dataset.endDate = new Date(endTime).toISOString();
        timeLeft = cycleMs;
      }
      
      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
      
      this.setValue('.countdown-timer__days-number', days);
      this.setValue('.countdown-timer__hours-number', hours);
      this.setValue('.countdown-timer__minutes-number', minutes);
      this.setValue('.countdown-timer__seconds-number', seconds);
      
      const timeString = `${days} ${this.dataset.daysText}, ${hours} ${this.dataset.hoursText}, ${minutes} ${this.dataset.minutesText}, ${seconds} ${this.dataset.secondsText}`;
      this.setAttribute('aria-label', `Time remaining: ${timeString}`);
      
      if (timeLeft === 0 && this.dataset.behavior === 'stop') {
        this.stopTimer();
        this.dispatchEvent(new CustomEvent('countdown:finished', {
          bubbles: true,
          detail: { timer: this }
        }));
      }
      if (timeLeft === 0 && this.dataset.behavior === 'hide') {
        this.setAttribute('aria-hidden', 'true');
        this.stopTimer();
        this.dispatchEvent(new CustomEvent('countdown:finished', {
          bubbles: true,
          detail: { timer: this }
        }));
      }
    }
    
    setValue(selector, value) {
      const el = this.querySelector(selector);
      if (el) {
        const formatted = this.formatNumber(value);
        if (el.textContent !== formatted) {
          el.textContent = formatted;
          
          el.classList.add('countdown-timer__updating');
          setTimeout(() => {
            el.classList.remove('countdown-timer__updating');
          }, 200);
        }
      }
    }
  }
  
  customElements.define('countdown-timer', CountdownTimer);
  } catch(e) { console.error(e); }
})();

})();
